export default "__VITE_ASSET__01f5eae6__"